'use strict';

exports.__esModule = true;
exports.default = parseFieldName;
function parseFieldName(fieldName) {
  var isArray = fieldName.indexOf('[]') > -1;
  var baseName = isArray ? fieldName.replace('[]', '') : fieldName;

  return {
    isArray: isArray,
    baseName: baseName,
    fullName: fieldName
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/revalidate/lib/internal/parseFieldName.js
// module id = 2226
// module chunks = 204